import {ExamenDefinitionSummaryModel} from '../examenDefinitionSummary.model';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {FormDefinitionFormSummaryConverter} from '../../../../../form/definition/form/api/entity/converter/formDefinitionFormSummary.converter';
import {LovValueSummaryConverter} from '../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class ExamenDefinitionSummaryConverter extends HttpModelConverter<ExamenDefinitionSummaryModel> {

    constructor(private formDefinitionFormConverter: FormDefinitionFormSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): ExamenDefinitionSummaryModel {
        return new ExamenDefinitionSummaryModel();
    }

    protected enrichObject(result: ExamenDefinitionSummaryModel, src: ExamenDefinitionSummaryModel) {
        result.formDefinition = this.formDefinitionFormConverter.convert(src.formDefinition);
        result.types = this.lovValueSummaryConverter.convertFromArray(src.types);
    }

}
